// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-p_gi","advertDetailService__price":"c-p_gj"};